<div class="step-container">
    <form [formGroup]="Form">
        <div id="ohi-form-content" class="form-content">
            <div class="form-section inline-item mb-30 mt-10">
                <label class="label-question">
                    Do you have any other <u>commercial</u> health insurance plan?<br>
                    <label class="label-question-comment">
                        <i>Please do not include life, vision, or dental insurance plans.</i>
                    </label>
                </label>
                <app-toggle-confirm-dialog  id="ohi-toggle-has-ocp"
                                            #HasOtherCommercialHealthInsurancePlan
                                            formControlName="HasOtherHealthInsurance"
                                            class="question-answer-input"
                                            (Change)="HandleHasOtherCommercialHealthInsurancePlan($event)"
                                            [ShowLabel]="false"
                                            [ShowConfirmDialogForNO]="true"
                                            [ShowConfirmDialogForU]="false"
                                            [SkipModalWithEmit]="SkipValueHasOtherHealthInsurance()"
                                            [ShowButtonU]="false"
                                            [InputId]="'ohi-toggle-has-ocp'"
                                            [InputName]="'HasOtherHealthInsurance'">
                </app-toggle-confirm-dialog>
            </div>
            <div *ngIf="ShowHasOtherCommercialHealthInsurancePlan">
                <div formArrayName="PolicyHolders" class="pad-5">
                    <div id="ohi-accordion" class="accordion-button" *ngIf="ShowToggleButtonExpandPolicyHolder">
                        <button id="ohi-accordion-button" mat-raised-button
                                (click)="ExpandAllPolicyHolders()">
                                <mat-icon>unfold_more</mat-icon>
                                Expand All
                        </button>
                        <button mat-raised-button
                                (click)="CollapseAllPolicyHolders()">
                                <mat-icon>unfold_less</mat-icon>
                                Collapse All
                        </button>
                    </div>
                    <mat-accordion #AccordionPolicyHolder class="mat-accordion" multi>
                        <app-policy-holder
                            *ngFor="let policyHolderForm of PolicyHolders.controls; let i=index"
                            [id]="'ohi-ph-'+i"
                            [Form]="policyHolderForm"
                            [PolicyHolders]="PolicyHolders"
                            [Index]="i">
                        </app-policy-holder>
                    </mat-accordion>
                </div>
                <div class="form-section inline-item mb-30 mt-30" *ngIf="ShowQuestionDoYouOtherCoverage">
                    <label class="label-question">
                        Do you have any other coverage?
                    </label>
                    <app-toggle-confirm-dialog  id="ohi-toggle-hascoverage"
                                                #HasCoverage
                                                formControlName="HasCoverage"
                                                class="question-answer-input"
                                                (Change)="HandleHasOtherCoverage($event)"
                                                [ShowLabel]="false"
                                                [ShowConfirmDialogForNO]="true"
                                                [ShowConfirmDialogForU]="false"
                                                [SkipModalWithEmit]="true"
                                                [ShowButtonU]="false"
                                                [InputId]="'ohi-toggle-hascoverage'"
                                                [InputName]="'HasCoverage'">
                    </app-toggle-confirm-dialog>
                </div>
            </div>
            <div *ngIf="(ShowHasOtherCommercialHealthInsurancePlan===false) || (ShowHasOtherCommercialHealthInsurancePlan && ShowQuestionPatientCoveredByMedicare)">
                <div class="form-section inline-item mb-10 mt-30">
                    <div class="label-question mb-10">
                        Is the patient covered by Medicare?
                    </div>
                    <app-toggle-confirm-dialog  id="ohi-toggle-has-cm"
                        #HasCoveredMedicare
                        formControlName="HasCoveredMedicare"
                        class="question-answer-input"
                        (Change)="HandleHasCoveredMedicare($event)"
                        [ShowLabel]="false"
                        [ShowConfirmDialogForNO]="true"
                        [ShowConfirmDialogForU]="false"
                        [SkipModalWithEmit]="SkipValueCoveredMedicare()"
                        [ShowButtonU]="false"
                        [InputId]="'ohi-toggle-has-cm'"
                        [InputName]="'HasCoveredMedicare'">
                    </app-toggle-confirm-dialog>
                </div>
                <div class="form-section" *ngIf="ShowSectionPatientCoveredByMedicare">
                    <div class="label-question-light br-1">
                        <i>Please fill out the insurance information below:</i>
                    </div>
                    <div class="inline-item">
                        <enterprise-text-input  id="ohi-input-inb"
                                                Label="Name of Medicare Beneficiary"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('InsuranceNameBeneficiary', 'Name of Beneficiary')"
                                                formControlName="InsuranceNameBeneficiary"
                                                class="inline-form-input"
                                                [MaxLength]="InsuranceNameBeneficiaryMaxLength"
                                                [Appearance]="'outline'"
                                                [InputId]="'ohi-input-inb'"
                                                [InputName]="'InsuranceNameBeneficiary'">
                        </enterprise-text-input>
                        <enterprise-text-input  id="ohi-input-imi"
                                                Label="Medicare ID #"
                                                [ErrorMessageOverride]="SetErrorTooltipMessage('InsuranceMedicareId', 'Medicare ID #')"
                                                formControlName="InsuranceMedicareId"
                                                class="inline-form-input"
                                                [MaxLength]="InsuranceMedicareIdMaxLength"
                                                [Appearance]="'outline'"
                                                [InputId]="'ohi-input-imi'"
                                                [InputName]="'InsuranceMedicareId'">
                        </enterprise-text-input>
                        <enterprise-date-input  id="ohi-input-eda"
                                                Label="Effective Date - Hospital (Part A)"
                                                formControlName="InsuranceEffectiveDateHospital"
                                                class="inline-form-input"
                                                [Appearance]="'outline'"
                                                [InputId]="'ohi-input-eda'"
                                                [InputName]="'InsuranceEffectiveDateHospital'">
                        </enterprise-date-input>
                        <enterprise-date-input  id="ohi-input-edb"
                                                Label="Effective Date - Medical (Part B)"
                                                formControlName="InsuranceEffectiveDateMedical"
                                                class="inline-form-input"
                                                [Appearance]="'outline'"
                                                [InputId]="'ohi-input-edb'"
                                                [InputName]="'InsuranceEffectiveDateMedical'">
                        </enterprise-date-input>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
